import {
    ICurrency,
    ICurrencyData,
    CURRENCY_NAME_MAX_LENGTH,
    CURRENCY_SLUG_MAX_LENGTH
} from './index'

export class Currency implements ICurrency {
    readonly id: number
    readonly slug: string
    readonly name: string
    readonly coefficient: number

    constructor(data?: ICurrencyData) {
        this.id = data?.id || 0
        this.name = data?.name || data?.slug || 'EU'
        this.slug = data?.slug || '€'
        this.coefficient = data?.coefficient || 1
    }

    validate(): boolean {
        return (
            this.validateName()
            && this.validateSlug()
            && this.validateCoefficient()
        );
    }

    validateName(): boolean {
        let name = this.name;
        return !!name && name.length <= CURRENCY_NAME_MAX_LENGTH;
    }

    validateSlug(): boolean {
        let slug = this.slug;
        return !!slug && slug.length <= CURRENCY_SLUG_MAX_LENGTH;
    }

    validateCoefficient(): boolean {
        return this.coefficient > 0;
    }

}